const inputBox = document.getElementById('ort-input');
const inputLabel = document.getElementById('ort-label');
let searchTermState = null;
let searchLat = null;
let searchLng = null;

// Searchbar
const handleEnterKey = (event) => {
    if (event.key === 'Enter') {
        const address = event.target.value;
        if (address.length < 2) {
            return showErrorMessage("minCharacters");
        }

        if (address) {
            const urlParams = new URLSearchParams(window.location.search);
            searchTermState = address;
            findExerciseLocationMap.savedInputValue = address;

            const mapCheck = urlParams.has('map');
            if (!mapCheck) {
                findExerciseLocationMap.disableButtonDuringLoading()
            }

            findGeoCodingResults(address);
        }
    }
};

let isThrottled = false;

const cancelThrottle = (delay = 2000) => {
    isThrottled = true;
    setTimeout(() => {
        isThrottled = false;
    }, delay);
};

const findGeoCodingResults = async (searchTerm) => {

    if (isThrottled) return;

    const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

    let latitude = null;
    let longitude = null;

    const geocodeUrl = `/api/GoogleMaps/geocode-address?address=${encodeURIComponent(searchTerm)}`;

    const getUserLocation = async () => {
        await loadGoogleMaps();
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                (error) => {
                    console.warn("Geolocation error:", error);
                    reject(error);
                }
            );
        });
    };

    try {
        const response = await fetch(geocodeUrl);
        const data = await response.json();

        if (data.status === "OK" && data.results.length > 0) {
            const results = data.results;
            if (permissionStatus.state === 'granted') {
                try {
                    const userLocation = await getUserLocation();
                    latitude = userLocation.latitude;
                    longitude = userLocation.longitude;
                } catch (error) {
                    console.warn("Using fallback location due to geolocation error.");
                }
            }

            if (!latitude || !longitude || permissionStatus.state === 'denied') {
                const { lat: centerLat, lng: centerLng } = results[0].geometry.location;
                latitude = centerLat;
                longitude = centerLng;
            }

            const closestResult = results.reduce((closest, result) => {
                const lat = result.geometry.location.lat;
                const lng = result.geometry.location.lng;
                const distance = utils["google-maps"].calculateDistance(latitude, longitude, lat, lng);

                return !closest || distance < utils["google-maps"].calculateDistance(latitude, longitude, closest.geometry.location.lat, closest.geometry.location.lng)
                    ? result
                    : closest;
            }, null);


            if (closestResult) {
                const { lat, lng } = closestResult.geometry.location;
                const userCenter = { lat, lng };

                // To load new pages with distance calculations
                searchLat = lat;
                searchLng = lng;

                // show-more-facilities.js
                window.loadMoreFacilities(true, searchTerm, lat, lng);

                //If user is on map view
                if (mapCheck()) {
                    showAllMarkers();
                    adjustMapToFitMarkers(userCenter, searchTerm);
                }
            } else {
                showErrorMessage("noResults");
            }
        } else {
            try {
                searchLat = null;
                searchLng = null;

                // show-more-facilities.js
                const facilityData = window.loadMoreFacilities(true, searchTerm);

                if (!facilityData) {
                    showErrorMessage("noResults");
                }
            } catch (error) {
                showErrorMessage("generalError");
            }
        }
        cancelThrottle();
    } catch (error) {
        showErrorMessage("generalError");
    }
}

// Show position button
handleShowPosition = async () => {
    if (isThrottled) return;
    const urlParams = new URLSearchParams(window.location.search);

    const mapCheck = urlParams.has('map');
    if (!mapCheck) findExerciseLocationMap.disableButtonDuringLoading();

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
            const { latitude, longitude } = position.coords;

            const geocodeUrl = `/api/GoogleMaps/geocode-reverse?latlng=${latitude},${longitude}`;
            try {
                const response = await fetch(geocodeUrl);
                const data = await response.json();

                if (data.status === "OK" && data.results.length > 0) {
                    const addressComponents = data.results[0].address_components;
                    const cityComponent = addressComponents.find(component =>
                        component.types.includes("locality") || component.types.includes("postal_town")
                    );

                    if (cityComponent) {
                        const cityName = cityComponent.long_name.toLowerCase();
                        inputBox.value = cityName;
                        findExerciseLocationMap.savedInputValue = cityName;
                        searchTermState = cityName;
                        findGeoCodingResults(cityName);
                    } else {
                        showErrorMessage("noResults");
                    }
                } else {
                    showErrorMessage("generalError");
                }
            } catch (error) {
                showErrorMessage("generalError");
            }
            cancelThrottle();
        }, (error) => {
            showErrorMessage("geolocationNotEnabled")
        });
    } else {
        showErrorMessage("geolocationNotEnabled")
    }

};

showErrorMessage = (key, duration = 5000) => {
    const message = window.umbracoTranslations[key] || window.umbracoTranslations.generalError;

    utils.common.showElement(findExerciseLocationMap.facilityError);
    findExerciseLocationMap.facilityError.innerText = message;
    setTimeout(() => {
        findExerciseLocationMap.facilityError.innerText = ""
        utils.common.hideElement(findExerciseLocationMap.facilityError)
    }, duration)
};

document.addEventListener('DOMContentLoaded', () => {
    if (inputBox) {
        inputBox.addEventListener('keydown', handleEnterKey);
    }
});
